var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("autocomplete", {
        attrs: {
          "get-list": _vm.getList,
          label: "Фактический адрес проживания",
          "required-mark": _vm.field.required,
          invalid: !!_vm.error,
          error: _vm.error,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }